export const WpCalculationType = {
    ACTUAL: 'actual',
    PERCENT_TO_TARGET: '% to target',
};
